var _rect, _rect2, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTypeCorrectiveMaintenance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#C2C2C2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7141 12.1463C18.597 12.258 19.5147 11.9752 20.1919 11.2981C21.0649 10.425 21.2832 9.14768 20.8491 8.07123L19.3064 9.61397C19.1055 9.81488 18.7855 9.81488 18.5846 9.61397L17.657 8.68635C17.4561 8.48544 17.4561 8.16549 17.657 7.96458L19.1997 6.42184C18.1233 5.98779 16.846 6.20606 15.9729 7.07912C15.1122 7.93978 14.8915 9.1948 15.3007 10.2613L6.41139 19.1507C5.8186 19.7435 5.8186 20.7058 6.41139 21.2986C7.00418 21.8914 7.96653 21.8914 8.55932 21.2986L17.7116 12.1463H17.7141ZM7.9318 20.49C7.73586 20.686 7.41838 20.686 7.22244 20.49C7.0265 20.2941 7.0265 19.9766 7.22244 19.7807C7.41838 19.5847 7.73586 19.5847 7.9318 19.7807C8.12775 19.9766 8.12775 20.2941 7.9318 20.49Z",
    fill: "#474747"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4327 21.2815L21.3236 21.3906C20.572 22.0578 19.5948 22.1992 19.1012 21.7056L14.2027 16.8095C14.0216 16.6284 13.9398 16.301 13.853 15.9513C13.7066 15.3734 13.5305 14.6616 12.7988 14.3267L14.3614 12.7642C14.7012 13.4934 15.4106 13.6719 15.986 13.8183C16.3357 13.9051 16.6631 13.9869 16.8442 14.168L21.7427 19.0641C22.2363 19.5527 22.0974 20.5299 21.4302 21.2839L21.4327 21.2815Z",
    fill: "#FFC300"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2461 21.1251L20.0948 21.2764C19.9758 21.3955 19.7823 21.3955 19.6657 21.2764L14.6332 16.2439C14.5142 16.1248 14.5142 15.9314 14.6332 15.8148L14.7845 15.6635C14.9036 15.5445 15.097 15.5445 15.2136 15.6635L20.2461 20.696C20.3652 20.8126 20.3652 21.006 20.2461 21.1251Z",
    fill: "#CC7A00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3252 20.0438L21.1739 20.1951C21.0549 20.3142 20.8614 20.3142 20.7448 20.1951L15.7123 15.1626C15.5933 15.0435 15.5933 14.8501 15.7123 14.7335L15.8636 14.5822C15.9827 14.4632 16.1761 14.4632 16.2927 14.5822L21.3252 19.6147C21.4443 19.7313 21.4443 19.9247 21.3252 20.0438Z",
    fill: "#CC7A00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.467 8.86002L7.12765 8.47061L5.96191 6.62776L6.58943 6.00024L8.50421 7.06181L8.91346 8.41852L13.8443 13.2972L13.3978 13.7437L8.467 8.86002Z",
    fill: "#A3A3A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeCorrectiveMaintenance);
export default __webpack_public_path__ + "static/media/Type=CorrectiveMaintenance.8cd7c6286be5b0e6839dab9fdd7e47fd.svg";
export { ForwardRef as ReactComponent };